import { MIN_LENGTH, MAX_LENGTH } from '../constants';
import { InputTextProperty } from '../enums';

const InputTextProps = {
  props: {
    [InputTextProperty.MaxLength]: {
      default: MAX_LENGTH,
      type: Number,
    },
    [InputTextProperty.MinLength]: {
      default: MIN_LENGTH,
      type: Number,
    },
  },
};

export default InputTextProps;
